module.exports = __webpack_public_path__ + "media/pages/assets/images/gallery/2021/may-477dfd33c5312dc1656b4b48063497de.png";